import { useAtom } from 'jotai';
import { useEffect } from 'react';
import {
  isEditorialClipMapAtom,
  isEditorialClipQueueAtom,
  isEditorialMapAtom,
  isEditorialQueueAtom,
} from '../store/store';
import { trpc } from '../utils/trpc';
import { MediaType } from '@/utils/mediaHelpers';

export default function useIsEditorial(assetId: number, mediaType: MediaType, enabled = true) {
  if (mediaType !== 'clip' && mediaType !== 'photo') {
    return { isEditorial: false, refetch: () => {} };
  }

  const context = trpc.useContext();

  const [isEditorialMap, setIsEditorialMap] = useAtom(isEditorialMapAtom);
  const [isEditorialQueue, setIsEditorialQueue] = useAtom(isEditorialQueueAtom);
  const [isEditorialClipMap, setIsEditorialClipMap] = useAtom(isEditorialClipMapAtom);
  const [isEditorialClipQueue, setIsEditorialClipQueue] = useAtom(isEditorialClipQueueAtom);

  useEffect(() => {
    if (mediaType === 'photo') {
      if (enabled && isEditorialMap[assetId] === undefined && !isEditorialQueue.includes(assetId)) {
        setIsEditorialQueue((prev) => [...prev, assetId]);
      }
    } else if (mediaType === 'clip') {
      if (
        enabled &&
        isEditorialClipMap[assetId] === undefined &&
        !isEditorialClipQueue.includes(assetId)
      ) {
        setIsEditorialClipQueue((prev) => [...prev, assetId]);
      }
    }
  }, [
    assetId,
    enabled,
    isEditorialMap,
    setIsEditorialQueue,
    mediaType,
    isEditorialClipMap,
    setIsEditorialClipQueue,
  ]);

  function refetch() {
    if (mediaType === 'photo') {
      context.client.photos.isEditorial.query([assetId]).then((res) => {
        setIsEditorialMap((prev) => ({ ...prev, ...res }));
      });
    } else if (mediaType === 'clip') {
      context.client.packs.isEditorial.query([assetId]).then((res) => {
        setIsEditorialClipMap((prev) => ({ ...prev, ...res }));
      });
    }
  }

  const isEditorial =
    mediaType === 'photo' ? isEditorialMap[assetId] || false : isEditorialClipMap[assetId] || false;

  return {
    isEditorial,
    refetch,
  };
}
